export default __webpack_public_path__ + "static/logos-tiles-amgen-4fd633e567ac6eb16bed4854b85a0a66.svg";